export function downloadFromBlob(blob: Blob, filename: string) {
  const blobUrl = URL.createObjectURL(blob);
  try {
    const element = document.createElement("a");
    element.href = blobUrl;
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } finally {
    URL.revokeObjectURL(blobUrl); // Clean up the blob URL to prevent memory leaks
  }
}
